var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBowlerHandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28.572,
    viewBox: "0 0 25 28.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bowler_-_Hand_Icon",
    "data-name": "Bowler - Hand Icon",
    d: "M7.143,22.811a2.267,2.267,0,0,1,2.276-2.276h4.867v-.446H4.453a2.267,2.267,0,0,1-2.276-2.276,2.232,2.232,0,0,1,2.232-2.189h9.877v-.446H2.276A2.267,2.267,0,0,1,0,12.9a2.232,2.232,0,0,1,2.232-2.189H14.286v-.446H4.508A2.267,2.267,0,0,1,2.233,7.992,2.232,2.232,0,0,1,4.464,5.8H17.634l-2.022-1.47-.407-.3A2.232,2.232,0,0,1,17.831.427C28.161,7.94,28.571,8.745,28.572,9.6V20.629a2.679,2.679,0,0,1-2.065,2.607L20.22,24.715A10.716,10.716,0,0,1,17.766,25H9.375a2.232,2.232,0,0,1-2.232-2.189ZM16.374,5.455Z",
    transform: "translate(25) rotate(90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowlerHandIcon);
export default __webpack_public_path__ + "static/media/Bowler_Hand_Icon.aacd66b5ef1660ef64863f7b34b4f3a0.svg";
export { ForwardRef as ReactComponent };